<script lang="ts" setup>
import { computed } from 'vue'
import { useSwiper } from '~/composables/common/use-swiper'
import { BaseTabVariant } from '~/enums'
import type { TabItem } from '~/types/app'

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  options: {
    type: Object,
    default: () => ({}),
  },
  tabs: {
    type: Array as () => TabItem[],
    required: true,
  },
  variant: {
    type: String as () => BaseTabVariant,
    default: BaseTabVariant.Default,
  },
  class: {
    type: String,
    default: '',
  },
  nextEl: {
    type: String,
    default: '',
  },
  prevEl: {
    type: String,
    default: '',
  },
})

const { Swiper, SwiperSlide, modules } = useSwiper()

const emit = defineEmits(['update:modelValue'])

const selectedTab = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const onValueUpdate = (value: string) => {
  selectedTab.value = value
}

const swiperRef = ref()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getRef(swiperInstance: any) {
  swiperRef.value = swiperInstance
  nextTick(() => {
    const index = props.tabs.findIndex(
      (tab: TabItem) => tab.key === selectedTab.value,
    )
    swiperRef.value?.slideTo(index < 1 ? 0 : index - 1, 300, false)
  })
}

watch(selectedTab, (value: string) => {
  const index = props.tabs.findIndex((tab: TabItem) => tab.key === value)
  swiperRef.value?.slideTo(index < 1 ? 0 : index - 1, 300, false)
})
</script>
<template>
  <Swiper
    :modules="modules"
    v-bind="options"
    :navigation="{
      nextEl: nextEl,
      prevEl: prevEl,
    }"
    @swiper="getRef"
  >
    <SwiperSlide
      v-for="(item, index) in tabs"
      :key="index"
      @click="onValueUpdate(item.key ?? '')"
    >
      <slot
        name="item"
        :item="item"
        :selected="item.key === selectedTab"
        :index="index"
      />
    </SwiperSlide>
  </Swiper>
</template>
